import React, { Component } from "react";

import Button from "carbon-components-react/lib/components/Button";
import Form from "carbon-components-react/lib/components/Form";
import { Information32 } from "@carbon/icons-react";

import "../../../../styles/components/sdgs/sdg_16_7_1c.css";
import "../../../../styles/css/AdminLTE.css";

import { notifyError, notifySuccess } from "../../../common/notification/NotificationHelper";

import { connect } from "react-redux";

import { Metadata } from "./components/Metadata";

import { sdg1633Actions, userActions } from "../../../../_actions";
import { IndicatorData } from "./components/IndicatorData";
import Spinner from "../../../common/spinner/Spinner";
import { commonService, sdg1633Service, userService } from "../../../../_services";

class SDG16_3_3 extends Component {
  constructor() {
    super();
    this.onSubmit = this.onSubmit.bind(this);
    this.handleTableChange = this.handleTableChange.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.onValidate = this.onValidate.bind(this);
    this.onSelectChange = this.onSelectChange.bind(this);
    this.onSaveWork = this.onSaveWork.bind(this);
    this.onNext = this.onNext.bind(this);
    this.onPrevious = this.onPrevious.bind(this);
  }

  state = {
    page: 1,
    processingData: false
  };

  componentDidMount() {
    const {
      match: { params }
    } = this.props;

    const { dispatch } = this.props;
    if (params.id !== undefined) {
      dispatch(sdg1633Actions.getIndicatorData(params.id));
    } else {
      dispatch(sdg1633Actions.clearIndicatorData());

      dispatch(
        sdg1633Actions.updateMetadataField(
          "country",
          this.props.user ? this.props.user.country : null
        )
      );
    }
  }

  onSubmit(event) {
    event.preventDefault();
    let data = this.props.data;

    const { dispatch } = this.props;

    this.setState({processingData: true});

    sdg1633Service.saveIndicatorData(data).then(
      data => {
        this.setState({processingData: false});
        dispatch(sdg1633Actions.saveIndicatorData(data));
      },
      error => {
        this.setState({processingData: false});
        if (error.response.status === 500) {
          notifyError(
            "Server not available at the moment. Please try again later."
          );
        } else if (error.response.status === 401) {
          notifyError("Session expired. Please login again!")
          const { dispatch } = this.props;
          dispatch(userActions.logout());
        }
        else {
          notifyError(
            "There are arrors on the form, please review data before submitting!"
          );
          dispatch(sdg1633Actions.saveSubmitErrors(error.response.data))
        }
      }
    );

  }

  onSubmitUndp = () => {
    const { dispatch } = this.props;
    let data = this.props.data;

    let finalizeStr = "sdg1633/" + this.props.data.id + "/review/";

    this.setState({processingData: true});
    sdg1633Service.saveIndicatorData(data).then(
      data => {
        this.setState({processingData: false});
        dispatch(sdg1633Actions.finalizeIndicatorData(finalizeStr, data));
        commonService.finalizeIndicatorData(finalizeStr).then(data => {
          this.setState({processingData: false});
          dispatch(sdg1633Actions.finalizeIndicatorData(finalizeStr, data));
        });
      },
      error => {
        this.setState({processingData: false});
        if (error.response.status === 500) {
          notifyError(
            "Server not available at the moment. Please try again later."
          );
        } else if (error.response.status === 401) {
          notifyError("Session expired. Please login again!")
          const { dispatch } = this.props;
          dispatch(userActions.logout());
        }
         else {
          notifyError(
            "There are arrors on the form, please review data before submitting!"
          );
          dispatch(sdg1633Actions.saveSubmitErrors(error.response.data))
        }
      }
    );


  };

  handleChange(e) {
    this.setState({
      data: { ...this.state.data, [e.target.name]: e.target.value }
    });
  }

  handleTableChange(name, value) {
    this.setState({ data: { ...this.state.data, [name]: value } });
  }

  onValidate(e) {
    let data = { pk: this.props.data.id };

    let validateStr = this.props.data.status !== 'validated'
      ? "sdg1633/" + this.props.data.id + "/validate/"
      : "sdg1633/" + this.props.data.id + "/unvalidate/";

      const { dispatch } = this.props;

      this.setState({processingData: true});
      commonService.validateIndicatorData(validateStr, data).then(
        data => {
          this.setState({processingData: false});
          dispatch(sdg1633Actions.validateIndicatorData(validateStr, data));
        },
        error => {
          this.setState({processingData: true});
          if (error.response.status === 500) {
            notifyError(
              "Server not available at the moment. Please try again later."
            );
          } else if (error.response.status === 401) {
            notifyError("Session expired. Please login again!")
            const { dispatch } = this.props;
            dispatch(userActions.logout());
          } else {
            notifyError(
              "There are arrors on the form, please review data before submitting!"
            );
            // dispatch(save_data_failure(error.response.data));
          }
        }
      );
  
  }

  onSelectChange(e) {
    this.setState({ nature_of_data: e.target.value });
  }

  onSaveWork() {
    localStorage.setItem("sdg1633", JSON.stringify(this.state.data));
    notifySuccess("Data saved succesfully!");
  }

  onNext() {
    let page = this.state.page;

    this.setState({ page: page + 1 });
  }

  onPrevious() {
    let page = this.state.page;

    this.setState({ page: page - 1 });
  }

  render() {
    let validateTitle =
      this.props.data && this.props.data.status === 'validated'
        ? "Unlock for edit"
        : "Validate / Lock";

    // let saveButton =
    //   this.props.data && !this.props.data.validated ? (
    //     <div className="col-sm-3">
    //       <Button onClick={this.onSaveWork}>Save work</Button>
    //     </div>
    //   ) : null;

    let disableEntry = this.props.user ? 
      this.props.user.user_type === 'OGC' && 
      this.props.data && this.props.data.status === "validated" ? true : 
      (this.props.data && this.props.user.user_type === 'NSO' && this.props.data.status !== "entry") ? true : 
        (this.props.data && this.props.user.user_type === 'OECD_UNODC' ? true : false) : false;

      console.log("Disabled: ", disableEntry, this.props.user ? this.props.user.user_type : "Nema", this.props.data);

    let validateButton =
      this.props.user && this.props.user.user_type === "OGC" ? (
        // <div className="col-sm-12">
        <Button onClick={this.onValidate}>
          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          {validateTitle}
        </Button>
      ) : // </div>
      null;

    let notifyButton =
        this.state.page === 2 &&
        this.props.data &&
        this.props.data.status === "entry"&&
        this.props.user &&
        this.props.user.user_type === "NSO" ? (
        <Button
          onClick={this.onSubmitUndp}
          style={{ marginRight: "25px" }}
          className="button-bottom"
        >
          Submit to UNDP
        </Button>
      ) : null;

      let saveButton = this.props.data &&
      this.props.user &&
      ((this.props.user.user_type === "NSO" && this.props.data.status === 'entry') ||
        (this.props.user.user_type === "OGC" && this.props.data.status !== 'validated')) ? (
          <Button
            onClick={this.onSubmit}
            style={{ marginRight: "25px" }}
            className="button-bottom"
          >
            Save data
          </Button>) : null;


    let submitButton =
      (
        <div className="col-sm-12">
          {saveButton}
          {notifyButton}
          {validateButton}
        </div>
      );

    let contentData =
      this.state.page === 1 ? (
        <Metadata
          // data={this.state.data}
          error={this.state.error}
          onHandleChange={this.handleChange}
        />
      ) : (
        <IndicatorData
          onDataChange={this.handleTableChange}
          onPrevious={this.onPrevious}
        />
      );

    let content = (
      <div>
        <Form onSubmit={this.onSubmit}>
          <fieldset disabled={disableEntry}>
            {/* {header} */}
            {contentData}
          </fieldset>

          <div className="row introduction-bottom">
            <div className="col-sm-12">
              {this.state.page !== 1 ? (
                <Button
                  onClick={this.onPrevious}
                  disabled={this.state.page === 1}
                  style={{ width: "135px" }}
                >
                  &lt;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Back
                </Button>
              ) : null}
              {this.state.page !== 2 ? (
                <Button
                  onClick={this.onNext}
                  disabled={this.state.page === 3}
                  style={{
                    marginLeft: "50px",
                    width: "135px",
                    float: "right"
                  }}
                >
                  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Continue&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&gt;
                </Button>
              ) : null}
            </div>
          </div>
          <div className="row" style={{ textAlign: "center" }}>
            {submitButton}
            {/* {validateButton} */}
          </div>
        </Form>
      </div>
    );

    return (
      <div id="content-wrapper" className="content-wrapper">
        {this.state.processingData && <Spinner />}
        <section className="indicator-header" style={{ display: "flex" }}>
          <img
            src="/resources/img/Icon_16-3-3.png"
            style={{ height: "55px", marginRight: "10px" }}
            alt="Icon 1633"
          />
          <h1>16.3.3: Proportion of the population who have experienced a dispute in the past two years and who accessed a formal or informal dispute resolution mechanism, by type of mechanism</h1>
          <div style={{ paddingTop: "10px" }}>
            <a
              title="Click to see indicator brief"
              target="_blank"
              rel="noopener noreferrer"
              href="https://unstats.un.org/sdgs/metadata/files/Metadata-16-03-03.pdf"
            >
              <Information32 />
            </a>
          </div>
        </section>
        <section className="content">
          <div className="box">
            <div className="box-body">{content}</div>
          </div>
        </section>
      </div>
    );
  }
}

function mapStateToProps(state) {
  const { user } = state.authentication;
  const { data, error } = state.sdg1633State;

  return {
    user,
    data,
    error
  };
}

const connectedIndicator = connect(mapStateToProps)(SDG16_3_3);
export { connectedIndicator as SDG16_3_3 };
